import { all, call, fork, takeLatest } from 'redux-saga/effects';

import * as constants from './company-tools-categories.constants';
import * as types from './company-tools-categories.types';
import * as services from './company-tools-categories.saga-services';

function* invokeSetupCompanyToolsCategories(action: types.ISetupCompanyToolsCategories) {
  yield call(services.setupCompanyToolsCategories);
}

function* invokeCreateCompanyToolsCategory(action: types.ICreateCompanyToolsCategory) {
  yield call(services.createCompanyToolsCategory, action.payload);
}

function* invokeUpdateCompanyToolsCategory(action: types.IUpdateCompanyToolsCategory) {
  yield call(services.updateCompanyToolsCategory, action.payload.id, action.payload.data);
}

function* invokeDeleteCompanyToolsCategory(action: types.IDeleteCompanyToolsCategory) {
  yield call(services.deleteCompanyToolsCategory, action.payload.companyToolsCategoryId);
}

export function* watchCompanyToolsCategoriesPurePageSaga() {
  yield takeLatest(constants.SETUP_COMPANY_TOOLS_CATEGORIES, invokeSetupCompanyToolsCategories);
  yield takeLatest(constants.CREATE_COMPANY_TOOLS_CATEGORY, invokeCreateCompanyToolsCategory);
  yield takeLatest(constants.UPDATE_COMPANY_TOOLS_CATEGORY, invokeUpdateCompanyToolsCategory);
  yield takeLatest(constants.DELETE_COMPANY_TOOLS_CATEGORY, invokeDeleteCompanyToolsCategory);
}

export function* watchCompanyToolsCategoriesPageStorageSaga() {
  yield all([watchCompanyToolsCategoriesPurePageSaga].map(fork));
}
